import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import MilesLogo from "@/components/Logo";
import { useRobots } from "@/components/seo/Seo";

// 404 — UX propre côté client ; le statut HTTP 404 est assuré par la couche
// statique (404.html généré au build). Toujours noindex.
export default function NotFound() {
  useRobots("noindex, nofollow");
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-white px-6 text-center" data-testid="not-found-page">
      <Link to="/fr" aria-label="MILES — retour à l'accueil">
        <MilesLogo variant="blue" className="h-7" testId="not-found-logo" />
      </Link>
      <p className="mt-12 font-mono text-[11px] uppercase tracking-[0.35em] text-miles">Erreur 404</p>
      <h1 className="mt-4 max-w-lg text-4xl font-semibold tracking-[-0.04em] text-ink sm:text-5xl">
        Cette page n'existe pas.
      </h1>
      <p className="mt-4 max-w-md text-sm leading-relaxed text-slate">
        L'adresse demandée est introuvable — elle a peut-être été déplacée ou renommée.
        This page could not be found. Diese Seite existiert nicht.
      </p>
      <Link to="/fr" data-testid="not-found-home"
        className="mt-10 inline-flex items-center gap-2 rounded-full bg-miles px-7 py-3.5 text-sm font-semibold text-white transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-miles-dark">
        <ArrowLeft className="h-4 w-4" strokeWidth={2} /> Retour à l'accueil
      </Link>
    </div>
  );
}
